import script from "./AdminOrderDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrderDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrderDashboardView.vue?vue&type=style&index=0&id=c7e98152&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7e98152"]])

export default __exports__